export default "/fr/_next/static/assets/images/favicon.dff3146d2f39f776ffa2357f1f52ea04.png";